export default "__VITE_ASSET__B$LoxKdo__"